import { useQuery, type UseQueryResult, type UseQueryOptions } from '@tanstack/react-query';
import { eventsService } from '../../../api/services/events';
import type { EventsResponse, GetEventsParams, EventDetailResponse } from '../../../api/services/events';

export const eventKeys = {
  all: ['events'] as const,
  lists: () => [...eventKeys.all, 'list'] as const,
  list: (params?: GetEventsParams) => [...eventKeys.lists(), params] as const,
  details: () => [...eventKeys.all, 'detail'] as const,
  detail: (id: string) => [...eventKeys.details(), id] as const,
};

export const useGetEvents = (
  params?: GetEventsParams,
  options?: Omit<UseQueryOptions<EventsResponse, Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<EventsResponse, Error> => {
  return useQuery({
    queryKey: eventKeys.list(params),
    queryFn: () => eventsService.getEvents(params),
    ...options,
  });
};

export const useGetEventById = (
  id: string,
  options?: Omit<UseQueryOptions<EventDetailResponse, Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<EventDetailResponse, Error> => {
  return useQuery({
    queryKey: eventKeys.detail(id),
    queryFn: () => eventsService.getEventById(id),
    ...options,
  });
};
